import { render } from "./Outliers.vue?vue&type=template&id=3af0242b&ts=true"
import script from "./Outliers.vue?vue&type=script&lang=ts"
export * from "./Outliers.vue?vue&type=script&lang=ts"

import "./Outliers.vue?vue&type=style&index=0&id=3af0242b&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__